import { gql } from 'apollo-angular';

export const GET_TASKS = gql`
  query tasks($search: String) {
    tasks(search: $search) {
      id
      taskName
      taskCode
      # price
      # estimatedTime
    }
  }
`;

export const GET_TASK_BY_ID = gql`
  query task($id: Int!) {
    task(id: $id) {
      id
      taskName
      taskCode
      # price
      # estimatedTime
      taskCheckListItems {
        id
        itemName
      }
      taskVariants {
        id
        taskId
        variantName
        price
        estimatedTime
      }
    }
  }
`;

export const GET_ALL_SERVICE_TASKS_OF_A_SERVICE = gql`
  query findAllServiceTasksOfAService($serviceId: Int!) {
    findAllServiceTasksOfAService(serviceId: $serviceId) {
    id
    serviceId
    serviceData {
      id
      branchId
      totalPrice
    }
    taskId
    taskData {
      id
      taskName
      taskCode
      # taskCheckListItems
      taskVariants{
        id
        taskId
        variantName
        price
        estimatedTime
      }
    }
    isMandatory
    sequenceOrder
    status
  }
  }
`;
